import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cfgl",
  "use": "icon-cfgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cfgl\"><path d=\"M714.666667 117.333333v64h170.666666v704h-746.666666v-704h170.666666v-64h405.333334z m-405.333334 128h-106.666666v576h618.666666v-576h-106.666666v64h-405.333334v-64z m234.666667 128l-0.021333 160H704v64h-160.021333l0.021333 160h-64l-0.021333-160H320v-64h159.978667l0.021333-160h64z m106.666667-192h-277.333334v64h277.333334v-64z\" fill=\"#ffffff\" p-id=\"4312\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol